import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/prelogin/home/home.component';
import { LoginComponent } from './components/prelogin/login/login.component';
import { EntraLoginComponent } from './components/prelogin/entra-login/entra-login.component';
import { ForgotpasswordComponent } from './components/prelogin/forgotpassword/forgotpassword.component';
import { InsuranceloginComponent } from './components/prelogin/insurancelogin/insurancelogin.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HelpRequestComponent } from './components/shared/help-request/help-request.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppConfig } from './app.config';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FileUploadModule } from 'primeng/fileupload';
import { SidebarModule } from 'primeng/sidebar';
import { DialogModule } from 'primeng/dialog';
import { MenuModule } from 'primeng/menu';
import { PanelMenuModule } from 'primeng/panelmenu';
import { StepsModule } from 'primeng/steps';
import { TabMenuModule } from 'primeng/tabmenu';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DataViewModule } from 'primeng/dataview';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputTextModule } from 'primeng/inputtext';
import { TabViewModule } from 'primeng/tabview';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CardModule } from 'primeng/card';
import { RadioButtonModule } from 'primeng/radiobutton';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CarouselModule } from 'primeng/carousel';
import { ProgressBarModule } from 'primeng/progressbar';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CheckboxModule } from 'primeng/checkbox';
import { CalendarModule } from 'primeng/calendar';
import { MessageModule } from 'primeng/message';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TooltipModule } from 'primeng/tooltip';
import { ListboxModule } from 'primeng/listbox';
import { SliderModule } from 'primeng/slider';
import { InplaceModule } from 'primeng/inplace';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { GalleriaModule } from 'primeng/galleria';
import { TreeModule } from 'primeng/tree';
import { ChipsModule } from 'primeng/chips';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ToolbarModule } from 'primeng/toolbar';
//import { LightboxModule } from 'primeng/lightbox';
//import { GMapModule } from 'primeng/gmap';
import { BlockUIModule } from 'primeng/blockui';
import { PanelModule } from 'primeng/panel';
import { FieldsetModule } from 'primeng/fieldset';
import { PaginatorModule } from 'primeng/paginator';

import { TreeTableModule } from 'primeng/treetable';
import { PickListModule } from 'primeng/picklist';
import { AccordionModule } from 'primeng/accordion';
import { BikeshopWizardComponent } from './components/prelogin/bikeshop-wizard/bikeshop-wizard.component';
import { CallbackXeroComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/callback-xero/callback-xero.component';
import { CallbackLightspeedComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/callback-lightspeed/callback-lightspeed.component';
import { CallbackVendComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/callback-vend/callback-vend.component';
import { CallbackShopifyComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/callback-shopify/callback-shopify.component';
import { CallbackSquareComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-square/callback-square/callback-square.component';
import { StripeConnectCallbackComponent } from './components/portal/bikeshop/in-app-payment-configuration/connect-stripe/stripe-connect-callback/stripe-connect-callback.component';
import { TFACodeComponent } from './components/prelogin/tfacode/tfacode.component';
import { TFASetupComponent } from './components/prelogin/tfasetup/tfasetup.component';
import { PortalComponent } from './components/portal/bikeshop/portal.component';
import { QuickLaunchComponent } from './components/portal/bikeshop/quick-launch/quick-launch.component';
import { DashboardComponent } from './components/portal/bikeshop/dashboard/dashboard.component';
import { RecordPaymentDetailsComponent } from './components/portal/bikeshop/record-payment-details/record-payment-details.component';
import { ManageSubscriptionsComponent } from './components/portal/bikeshop/manage-subscriptions/manage-subscriptions.component';
import { DueForServiceDetailComponent } from './components/portal/bikeshop/dashboard/due-for-service-detail/due-for-service-detail.component';
import { MyprofileComponent } from './components/portal/bikeshop/myprofile/myprofile.component';
import { TFAProfileSetupComponent } from './components/portal/bikeshop/myprofile/tfaprofile-setup/tfaprofile-setup.component';
import { CalendarComponent } from './components/portal/bikeshop/calendar/calendar.component';
import { ReportsComponent } from './components/portal/bikeshop/reports/reports.component';
import { ServicesComponent } from './components/portal/bikeshop/services/services.component';
import { MessageTypesComponent } from './components/portal/bikeshop/message-types/message-types.component';
import { PurchaseMessagingBundleComponent } from './components/portal/bikeshop/purchase-messaging-bundle/purchase-messaging-bundle.component';
import { PosProductsComponent } from './components/portal/bikeshop/pos-products/pos-products.component';
import { PosProductsAddToCollectionComponent } from './components/portal/bikeshop/pos-products/add-to-collection/pos-products-add-to-collection.component';
import { ImportProductsComponent } from './components/portal/bikeshop/pos-products/import-products/import-products.component';
import { AddEditServicesComponent } from './components/shared/shared-service/add-edit-services/add-edit-services.component';
import { ServiceTypesComponent } from './components/portal/bikeshop/service-types/service-types.component';
import { ImportServiceTypesComponent } from './components/portal/bikeshop/service-types/import-service-types/import-service-types.component';
import { ChecklistItemsComponent } from './components/portal/bikeshop/checklist-items/checklist-items.component';
import { ChecklistConfigurationComponent } from './components/portal/bikeshop/checklist-configuration/checklist-configuration.component';
import { ShopProfileComponent } from './components/portal/bikeshop/shop-profile/shop-profile.component';
import { SettingsComponent } from './components/portal/bikeshop/settings/settings.component';
import { PosIntegrationsComponent } from './components/portal/bikeshop/pos-integrations/pos-integrations.component';
import { CollectionsSetupV2Component } from './components/portal/bikeshop/collections-setup-v2/collections-setup-v2.component';
import { CyclistsComponent } from './components/portal/bikeshop/cyclists/cyclists.component';
import { ImportCyclistsComponent } from './components/portal/bikeshop/cyclists/import-cyclists/import-cyclists.component';
import { UsersV2Component } from './components/portal/bikeshop/users-v2/users-v2.component';
import { UsersComponent } from './components/portal/bikeshop/users/users.component';
import { ThirdPartyComponent } from './components/portal/bikeshop/third-party/third-party.component';
import { SpecialOrdersComponent } from './components/portal/bikeshop/special-orders/special-orders.component';
import { CollectionsComponent } from './components/portal/bikeshop/collections/collections.component';
import { CommunityComponent } from './components/portal/bikeshop/community/community.component';
import { CommunicationComponent } from './components/portal/bikeshop/community/communication/communication.component';
import { InAppPaymentConfigurationComponent } from './components/portal/bikeshop/in-app-payment-configuration/in-app-payment-configuration.component';
import { InsuranceQuoteCreationComponent } from './components/portal/bikeshop/insurance/insurance.component';
import { SwitchShopComponent } from './components/portal/bikeshop/switch-shop/switch-shop.component';
import { OtherSettingsComponent } from './components/portal/bikeshop/other-settings/other-settings.component';
import { OnlineWidgetComponent } from './components/portal/bikeshop/online-widget/online-widget.component';
import { CouponsComponent } from './components/portal/bikeshop/coupons/coupons.component';
import { CouponDetailComponent } from './components/portal/bikeshop/coupons/coupon-detail/coupon-detail.component';
import { JobCardMessagesComponent } from './components/portal/bikeshop/job-card-messages/job-card-messages.component';
import { ExternalRedirectComponent } from './components/portal/bikeshop/external-redirect/external-redirect.component';
import { BikeSalesComponent } from './components/portal/bikeshop/bike-sales/bike-sales.component';
import { InventoryAuditComponent } from './components/portal/bikeshop/inventory-audit/inventory-audit.component';
import { InventorySummaryComponent } from './components/portal/bikeshop/inventory-summary/inventory-summary.component';
import { ServiceImportsComponent } from './components/portal/bikeshop/service-imports/service-imports.component';
import { WidgetSetupComponent } from './components/portal/bikeshop/widget-setup/widget-setup.component';
import { ShopRidesComponent } from './components/portal/bikeshop/shop-rides/shop-rides.component';
import { CreateEditRideComponent } from './components/portal/bikeshop/shop-rides/create-edit-ride/create-edit-ride.component';
import { ShopRidesConfigurationComponent } from './components/portal/bikeshop/shop-rides-configuration/shop-rides-configuration.component';
import { ReferralsComponent } from './components/portal/bikeshop/referrals/referrals.component';
import { ProductRedirectLoaderComponent } from './components/portal/bikeshop/product-redirect-loader/product-redirect-loader.component';
import { ServiceDepositConfigurationComponent } from './components/portal/bikeshop/service-deposit-configuration/service-deposit-configuration.component';
import { RentalsConfigurationComponent } from './components/portal/bikeshop/rentals/rentals-configuration/rentals-configuration.component';
import { RentalsTimeConfigurationComponent } from './components/portal/bikeshop/rentals/rentals-time-configuration/rentals-time-configuration.component';
import { RentalsProductsAccessoriesComponent } from './components/portal/bikeshop/rentals/rentals-products-accessories/rentals-products-accessories.component';
import { RentalsFixedDurationConfigComponent } from './components/portal/bikeshop/rentals/rentals-fixed-duration-config/rentals-fixed-duration-config.component';
import { RentalsFlexibleDurationConfigComponent } from './components/portal/bikeshop/rentals/rentals-flexible-duration-config/rentals-flexible-duration-config.component';
import { ReservationsComponent } from './components/portal/bikeshop/rentals/reservations/reservations.component';
import { RentalsChecklistsComponent } from './components/portal/bikeshop/rentals/rentals-checklists/rentals-checklists.component';
import { RentalsCategoriesComponent } from './components/portal/bikeshop/rentals/rentals-categories/rentals-categories.component';
import { RentalsReservationsSummaryComponent } from './components/portal/bikeshop/rentals/rentals-reservations-summary/rentals-reservations-summary.component';
import { RentalsSettingsComponent } from './components/portal/bikeshop/rentals/rentals-settings/rentals-settings.component';
import { RentalReportsComponent } from './components/portal/bikeshop/rentals/rental-reports/rental-reports.component';
import { RentalCustomWidgetQuestionsComponent } from './components/portal/bikeshop/rentals/rental-custom-widget-questions/rental-custom-widget-questions.component';
import { PaystackIntegrationConfigurationComponent } from './components/portal/bikeshop/paystack-integration-configuration/paystack-integration-configuration.component';
import { RentalsSplitPaymentConfigurationComponent } from './components/portal/bikeshop/rentals/rentals-split-payment-configuration/rentals-split-payment-configuration.component';
import { RentalAffiliatesComponent } from './components/portal/bikeshop/rentals/rental-affiliates/rental-affiliates.component';
import { RentalAffiliateCommissionReportComponent } from './components/portal/bikeshop/rentals/rental-affiliate-commission-report/rental-affiliate-commission-report.component';
import { RentalsWidgetConfigurationComponent } from './components/portal/bikeshop/rentals/rentals-widget-configuration/rentals-widget-configuration.component';
import { DemosWidgetConfigurationComponent } from './components/portal/bikeshop/rentals/demos-widget-configuration/demos-widget-configuration.component';
import { PageNotFoundComponent } from './components/shared/page-not-found/page-not-found.component';
import { AddEditLeaveComponent } from './components/modals/add-edit-leave/add-edit-leave.component';
import { AddEditCloseDateComponent } from './components/modals/add-edit-close-date/add-edit-close-date.component';
import { SharedServiceComponent } from './components/shared/shared-service/shared-service.component';
import { CreateCommunicationComponent } from './components/portal/bikeshop/community/communication/create-communication/create-communication.component';
import { AddEditStaffLeaveComponent } from './components/portal/bikeshop/users-v2/staff-leave/add-edit-staff-leave/add-edit-staff-leave.component';
import { AvailabilityComponent } from './components/portal/bikeshop/calendar/availability/availability.component';
import { AddEditBikesaleItemComponent } from './components/portal/bikeshop/bike-sales/add-edit-bikesale-item/add-edit-bikesale-item.component';
import { AvatarComponent } from './components/shared/avatar/avatar.component';
import { ServiceTypeMessageTemplatesComponent } from './components/shared/shared-service/add-edit-services/service-type-message-templates/service-type-message-templates.component';
import { ServiceTypeMessageTemplateComponent } from './components/shared/shared-service/add-edit-services/service-type-message-template/service-type-message-template.component';
import { EmailEditorComponent, EmailEditorModule } from 'angular-email-editor';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { VideoPlayerComponent } from './components/modals/video-player/video-player.component';
import { UserEditComponent } from './components/modals/user-edit/user-edit.component';
import { UpdateJobcardComponent } from './components/modals/update-jobcard/update-jobcard.component';
import { SelectTechnicianModalComponent } from './components/modals/select-technician-modal/select-technician-modal.component';
import { ScheduleServiceComponent } from './components/modals/schedule-service/schedule-service.component';
import { RecordBikeSaleComponent } from './components/modals/record-bike-sale/record-bike-sale.component';
import { StripeBundlePaymentComponent } from './components/modals/payments/stripe-bundle-payment/stripe-bundle-payment.component';
import { ConnectPosComponent } from './components/modals/connect-pos/connect-pos.component';
import { ChangeMyPasswordComponent } from './components/modals/change-my-password/change-my-password.component';
import { CardDetailsComponent } from './components/modals/card-details/card-details.component';
import { CancelPackageComponent } from './components/modals/cancel-package/cancel-package.component';
import { AddEditUserComponent } from './components/modals/add-edit-user/add-edit-user.component';
import { AddEditServiceTypeV2Component } from './components/modals/add-edit-service-type-v2/add-edit-service-type-v2.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ServiceDropoffComponent } from './components/portal/cyclist/cyclist-portal/service-dropoff/service-dropoff.component';
import { JobcardApprovalComponent } from './components/portal/cyclist/cyclist-portal/jobcard-approval/jobcard-approval.component';
import { InsuranceQuotesComponent } from './components/portal/cyclist/cyclist-portal/insurance-quotes/insurance-quotes.component';
import { ProcurementComponent } from './components/portal/insurance/procurement/procurement.component';
import { ClaimInfoComponent } from './components/portal/insurance/external-access/claim-info/claim-info.component';
import { JobcardMultiQuoteApprovalComponent } from './components/portal/cyclist/cyclist-portal/jobcard-multi-quote-approval/jobcard-multi-quote-approval.component';
import { ClaimComponent } from './components/portal/insurance/portal/view-claims/claim/claim.component';
import { ViewClaimsComponent } from './components/portal/insurance/portal/view-claims/view-claims.component';
import { ViewTasksComponent } from './components/portal/insurance/portal/view-tasks/view-tasks.component';
import { CreateClaimComponent } from './components/portal/insurance/portal/create-claim/create-claim.component';
import { InsuranceComponent } from './components/portal/insurance/insurance.component';
import { SingleManufacturerBikeComponent } from './components/portal/cyclist/cyclist-portal/single-manufacturer-bike/single-manufacturer-bike.component';
import { CyclistResetPasswordComponent } from './components/portal/cyclist/cyclist-portal/reset-password/reset-password.component';
import { JobcardChecklistsComponent } from './components/portal/cyclist/cyclist-portal/jobcard-checklists/jobcard-checklists.component';
import { JobcardAttachmentsPhoneComponent } from './components/portal/cyclist/cyclist-portal/jobcard-attachments-phone/jobcard-attachments-phone.component';
import { JobcardInvoicesComponent } from './components/portal/cyclist/cyclist-portal/jobcard-invoices/jobcard-invoices.component';
import { JobcardMessagingComponent } from './components/portal/cyclist/cyclist-portal/jobcard-messaging/jobcard-messaging.component';
import { JobcardReviewComponent } from './components/portal/cyclist/cyclist-portal/jobcard-review/jobcard-review.component';
import { CyclistPortalComponent } from './components/portal/cyclist/cyclist-portal/cyclist-portal.component';
import { CyclistPaymentComponent } from './components/portal/cyclist/cyclist-portal/cyclist-payment/cyclist-payment.component';
import { QuillModule } from 'ngx-quill';
import { WizardServiceTypesComponent } from './components/prelogin/bikeshop-wizard/wizard-service-types/wizard-service-types.component';
import { WizardLinkPosComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/wizard-link-pos.component';
import { WizardUsersComponent } from './components/prelogin/bikeshop-wizard/wizard-users/wizard-users.component';
import { SharedServiceTypesComponent } from './components/shared/shared-service-types/shared-service-types.component';
import { LinkVendComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-vend/link-vend.component';
import { LinkLightspeedComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-lightspeed/link-lightspeed.component';
import { LinkXeroComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-xero/link-xero.component';
import { LinkShopifyComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-shopify/link-shopify.component';
import { LinkNorthmillComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-northmill/link-northmill.component';
import { LinkRetailexpressComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-retailexpress/link-retailexpress.component';
import { LinkCitruslimeComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-citruslime/link-citruslime.component';
import { LinkEposnowComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-eposnow/link-eposnow.component';
import { LinkWilmarComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-wilmar/link-wilmar.component';
import { LinkNetsuiteComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-netsuite/link-netsuite.component';
import { LinkSquareComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-square/link-square.component';
import { VendDefaultsComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-vend/vend-defaults/vend-defaults.component';
import { SquareDefaultsComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-square/square-defaults/square-defaults.component';
import { ShopifyDefaultsComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-shopify/shopify-defaults/shopify-defaults.component';
import { NetsuiteDefaultsComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-netsuite/netsuite-defaults/netsuite-defaults.component';
import { LightspeedDefaultsComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-lightspeed/lightspeed-defaults/lightspeed-defaults.component';
import { WizardShopProfileComponent } from './components/prelogin/bikeshop-wizard/wizard-shop-profile/wizard-shop-profile.component';
import { WizardAccountVerificationComponent } from './components/prelogin/bikeshop-wizard/wizard-account-verification/wizard-account-verification.component';
import { WizardRegistrationComponent } from './components/prelogin/bikeshop-wizard/wizard-registration/wizard-registration.component';
import { PasswordStrengthComponent } from './components/shared/password-strength/password-strength.component';
import { RatingModule } from 'ng-starrating';
import { TrailsManagementComponent } from './components/portal/superuser/super-user-portal/trails-management/trails-management.component';
import { TrailAddEditComponent } from './components/portal/superuser/super-user-portal/trails-management/trail-add-edit/trail-add-edit.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { SuperUserPortalComponent } from './components/portal/superuser/super-user-portal/super-user-portal.component';
import { PushNotificationBroadcastComponent } from './components/portal/superuser/super-user-portal/push-notification-broadcast/push-notification-broadcast.component';
import { MessagingBundleAdminComponent } from './components/portal/superuser/super-user-portal/messaging-bundle-admin/messaging-bundle-admin.component';
import { CycleShopsComponent } from './components/portal/superuser/super-user-portal/cycle-shops/cycle-shops.component';
import { CommonModule, DatePipe } from '@angular/common';
import { GearTypeAdvicesComponent } from './components/portal/superuser/super-user-portal/bike-gear-management/gear-type-advices/gear-type-advices.component';
import { GearTypeAdviceComponent } from './components/portal/superuser/super-user-portal/bike-gear-management/gear-type-advices/gear-type-advice/gear-type-advice.component';
import { BikeGearManagementComponent } from './components/portal/superuser/super-user-portal/bike-gear-management/bike-gear-management.component';
import { AnalyticsDashboardComponent } from './components/portal/superuser/super-user-portal/analytics-dashboard/analytics-dashboard.component';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { StatusNamesPipe } from './pipes/status-names.pipe';
import { FranchiseComponent } from './components/portal/superuser/super-user-portal/admin-tasks/franchise/franchise.component';
import { AdminTasksComponent } from './components/portal/superuser/super-user-portal/admin-tasks/admin-tasks.component';
import { CopyShopsComponent } from './components/portal/superuser/super-user-portal/admin-tasks/copy-shops/copy-shops.component';
import { MergeCyclistComponent } from './components/shared/merge-cyclist/merge-cyclist.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { StaffComponent } from './components/portal/bikeshop/users-v2/staff/staff.component';
import { WorkingScheduleComponent } from './components/portal/bikeshop/users-v2/working-schedule/working-schedule.component';
import { ClosingDatesComponent } from './components/portal/bikeshop/users-v2/closing-dates/closing-dates.component';
import { StaffLeaveComponent } from './components/portal/bikeshop/users-v2/staff-leave/staff-leave.component';
import { TechniciansReorderComponent } from './components/portal/bikeshop/users-v2/technicians-reorder/technicians-reorder.component';
import { EditEventComponent } from './components/portal/bikeshop/users-v2/closing-dates/event/edit-event.component';
import { AddMessagingBundleComponent } from './components/modals/add-messaging-bundle/add-messaging-bundle.component';
import { AddEditUserV2Component } from './components/modals/add-edit-user-v2/add-edit-user-v2.component';
import { AddEditFranchiseComponent } from './components/modals/add-edit-franchise/add-edit-franchise.component';
import { TechniciansScheduleComponent } from './components/portal/bikeshop/users-v2/working-schedule/technicians-schedule/technicians-schedule.component';
import { AvailabilityCalendarComponent } from './components/modals/user-edit/technician-availability/availability-calendar/availability-calendar.component';
import { AddEditThirdPartyComponent } from './components/modals/add-edit-third-party/add-edit-third-party.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { MenuCardComponent } from './components/shared/menu-card/menu-card.component';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { AddEditRentalProductComponent } from './components/portal/bikeshop/rentals/rentals-products-accessories/add-edit-rental-product/add-edit-rental-product.component';
import { BookRentalReservationComponent } from './components/portal/bikeshop/rentals/reservations/book-rental-reservation/book-rental-reservation.component';
import { RentalReservationUpdateComponent } from './components/portal/bikeshop/rentals/reservations/rental-reservation-update/rental-reservation-update.component';
import { RentalReservationWaiverComponent } from './components/portal/bikeshop/rentals/reservations/rental-reservation-update/rental-reservation-waiver/rental-reservation-waiver.component';
import { RentalReservationChecklistComponent } from './components/portal/bikeshop/rentals/reservations/rental-reservation-update/rental-reservation-checklist/rental-reservation-checklist.component';
import { RentalReservationMessagingComponent } from './components/portal/bikeshop/rentals/reservations/rental-reservation-update/rental-reservation-messaging/rental-reservation-messaging.component';
import { RentalReservationQuoteComponent } from './components/portal/bikeshop/rentals/reservations/rental-reservation-update/rental-reservation-quote/rental-reservation-quote.component';
import { RentalReservationJobCardComponent } from './components/portal/bikeshop/rentals/reservations/rental-reservation-update/rental-reservation-job-card/rental-reservation-job-card.component';
import { RentalReservationSummaryDetailComponent } from './components/portal/bikeshop/rentals/rentals-reservations-summary/rental-reservation-summary-detail/rental-reservation-summary-detail.component';
import { QRCodeModule } from 'angularx-qrcode';
import { AddEditProductCategoriesComponent } from './components/modals/rentals/add-edit-product-categories/add-edit-product-categories.component';
import { VersionCheckService } from './services/version-check.service';
import { RentalReservationSecurityDepositInfoComponent } from './components/portal/bikeshop/rentals/reservations/rental-reservation-update/rental-reservation-security-deposit-info/rental-reservation-security-deposit-info.component';
import { CaptureAuthorizedPaymentComponent } from './components/portal/bikeshop/rentals/reservations/rental-reservation-update/rental-reservation-security-deposit-info/capture-authorized-payment/capture-authorized-payment.component';
import { RentalReservationLongTermPaymentScheduleComponent } from './components/portal/bikeshop/rentals/reservations/rental-reservation-update/rental-reservation-long-term-payment-schedule/rental-reservation-long-term-payment-schedule.component';
import { RentalPaymentStatusComponent } from './components/portal/bikeshop/rentals/reservations/rental-reservation-update/rental-payment-status/rental-payment-status.component';
import { RentalsAvailabilityDatePickerComponent } from './components/portal/bikeshop/rentals/reservations/book-rental-reservation/rentals-availability-date-picker/rentals-availability-date-picker.component';
import { OverviewWidgetComponent } from './components/shared/overview-widget/overview-widget.component';
import { DeliveryVehicleConfigComponent } from './components/portal/bikeshop/collections-setup-v2/delivery-vehicle-config/delivery-vehicle-config.component';
import { CyclistComponent } from './components/shared/cyclist/cyclist.component';
import { RentalCustomPickupSlotsComponent } from './components/portal/bikeshop/rentals/rentals-time-configuration/rental-custom-pickup-slots/rental-custom-pickup-slots.component';
import { RentalOverrideStoreTimesComponent } from './components/portal/bikeshop/rentals/rentals-time-configuration/rental-override-store-times/rental-override-store-times.component';
import { AddEditRentalOverrideStoreTimeComponent } from './components/portal/bikeshop/rentals/rentals-time-configuration/rental-override-store-times/add-edit-rental-override-store-time/add-edit-rental-override-store-time.component';
import { AddEditRentalCustomPickupSlotComponent } from './components/portal/bikeshop/rentals/rentals-time-configuration/rental-custom-pickup-slots/add-edit-rental-custom-pickup-slot/add-edit-rental-custom-pickup-slot.component';
import { RentalsLinkAccessoriesProductsComponent } from './components/portal/bikeshop/rentals/rentals-products-accessories/rentals-link-accessories-products/rentals-link-accessories-products.component';
import { RentalAccessoriesComponent } from './components/portal/bikeshop/rentals/rentals-products-accessories/rental-accessories/rental-accessories.component';
import { RentalProductsComponent } from './components/portal/bikeshop/rentals/rentals-products-accessories/rental-products/rental-products.component';
import { AddEditRentalAccessoryComponent } from './components/portal/bikeshop/rentals/rentals-products-accessories/add-edit-rental-accessory/add-edit-rental-accessory.component';
import { AddEditFlexiblePriceGroupComponent } from './components/portal/bikeshop/rentals/rentals-flexible-duration-config/add-edit-flexible-price-group/add-edit-flexible-price-group.component';
import { AddEditPriceGroupComponent } from './components/portal/bikeshop/rentals/rentals-fixed-duration-config/add-edit-price-group/add-edit-price-group.component';
import { BetaMessageComponent } from './components/shared/beta-message/beta-message.component';
import { RentalAccessoryCategoriesComponent } from './components/portal/bikeshop/rentals/rentals-categories/rental-accessory-categories/rental-accessory-categories.component';
import { RentalProductCategoriesComponent } from './components/portal/bikeshop/rentals/rentals-categories/rental-product-categories/rental-product-categories.component';
import { RentalAffiliateConfigComponent } from './components/portal/bikeshop/rentals/rental-affiliates/rental-affiliate-config/rental-affiliate-config.component';
import { ProductAddEditComponent } from './components/portal/bikeshop/pos-products/product-add-edit/product-add-edit.component';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { CurrencyVATPipe } from './pipes/currency-vat.pipe';
import { LinkifyPipe } from './pipes/linkify.pipe';
import { EposnowDefaultsComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-eposnow/eposnow-defaults/eposnow-defaults.component';
import { CitruslimeDefaultsComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-citruslime/citruslime-defaults/citruslime-defaults.component';
import { RetailexpressDefaultsComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-retailexpress/retailexpress-defaults/retailexpress-defaults.component';
import { MessageTypePanelComponent } from './components/portal/bikeshop/message-types/message-type-panel/message-type-panel.component';
import { AddEditAccessoryCategoriesComponent } from './components/modals/rentals/add-edit-accessory-categories/add-edit-accessory-categories.component';
import { SubscriptionPaymentComponent } from './components/portal/bikeshop/manage-subscriptions/subscription-payment/subscription-payment.component';
import { SetupPeachPaymentsComponent } from './components/portal/bikeshop/in-app-payment-configuration/setup-peach-payments/setup-peach-payments.component';
import { ConnectStripeComponent } from './components/portal/bikeshop/in-app-payment-configuration/connect-stripe/connect-stripe.component';
import { JoyrideModule, JoyrideService } from 'ngx-joyride';
import { ConfigurationOverviewComponent } from './components/portal/bikeshop/dashboard/configuration-overview/configuration-overview.component';
import { HubtigerStarRatingComponent } from './components/shared/hubtiger-star-rating/hubtiger-star-rating.component';
import { OverrideSlotsConfigComponent } from './components/portal/bikeshop/collections-setup-v2/override-slots-config/override-slots-config.component';
import { UnavailableDatesConfigComponent } from './components/portal/bikeshop/collections-setup-v2/unavailable-dates-config/unavailable-dates-config.component';
import { DefaultSlotsConfigComponent } from './components/portal/bikeshop/collections-setup-v2/default-slots-config/default-slots-config.component';
import { DeliveryAreaConfigComponent } from './components/portal/bikeshop/collections-setup-v2/delivery-area-config/delivery-area-config.component';
import { AddEditChecklistItemComponent } from './components/portal/bikeshop/checklist-configuration/add-edit-checklist-item/add-edit-checklist-item.component';
import { ResetPasswordComponent } from './components/modals/add-edit-user/reset-password/reset-password.component';
import { LinkedFittingsComponent } from './components/modals/user-edit/linked-fittings/linked-fittings.component';
import { LinkedServiceTypesComponent } from './components/modals/user-edit/linked-service-types/linked-service-types.component';
import { TechnicianAvailabilityComponent } from './components/modals/user-edit/technician-availability/technician-availability.component';
import { LinkNewUserComponent } from './components/modals/update-jobcard/link-new-user/link-new-user.component';
import { FittingInfoComponent } from './components/modals/update-jobcard/fitting-info/fitting-info.component';
import { LinkJobcardsComponent } from './components/modals/update-jobcard/link-jobcards/link-jobcards.component';
import { ChecklistComponent } from './components/modals/update-jobcard/checklist/checklist.component';
import { CollectionsTabComponent } from './components/modals/update-jobcard/collections-tab/collections-tab.component';
import { JobcardAttachmentsComponent } from './components/modals/update-jobcard/jobcard-attachments/jobcard-attachments.component';
import { MessagingComponent } from './components/modals/update-jobcard/messaging/messaging.component';
import { BikeComponent } from './components/shared/bike/bike.component';
import { QuoteComponent } from './components/modals/update-jobcard/quote/quote.component';
import { JobcardComponent } from './components/modals/update-jobcard/jobcard/jobcard.component';
import { ComponentViewComponent } from './components/shared/component-view/component-view.component';
import { UserComponent } from './components/modals/add-edit-user/user/user.component';
import { TechnicianComponent } from './components/modals/add-edit-user/technician/technician.component';
import { TechnicianWorkingHoursComponent } from './components/modals/add-edit-user/technician-working-hours/technician-working-hours.component';
import { BikesComponent } from './components/modals/add-edit-user/bikes/bikes.component';
import { CyclistBikeComponent } from './components/shared/cyclist-bike/cyclist-bike.component';
import { MoveJobcardComponent } from './components/modals/update-jobcard/jobcard/move-jobcard/move-jobcard.component';
import { AddProductPanelComponent } from './components/modals/update-jobcard/quote/add-product-panel/add-product-panel.component';
import { EditWorkingHoursComponent } from './components/modals/edit-working-hours/edit-working-hours.component';
import { SkeletonLoadJobcardComponent } from './components/modals/update-jobcard/jobcard/skeleton-load-jobcard/skeleton-load-jobcard.component';
import { ServicePaymentHistoryComponent } from './components/modals/update-jobcard/quote/service-payment-history/service-payment-history.component';
import { QuoteOptionsComponent } from './components/modals/update-jobcard/quote-options/quote-options.component';
import { AddCyclistBikeComponent } from './components/modals/schedule-service/add-cyclist-bike/add-cyclist-bike.component';
import { ComponentEditComponent } from './components/modals/component-edit/component-edit.component';
import { EventComponent } from './components/modals/add-edit-user/technician/event/event.component';
import { NgChartsModule } from 'ng2-charts';
import { FullCalendarModule } from '@fullcalendar/angular';
//import { PowerBIEmbedModule } from 'powerbi-client-angular';
import { AgmCoreModule } from '@agm/core';
import { PrintComponent } from './components/portal/bikeshop/print-job-card-a4/print.component';
import { PrintJobCardTillSlipComponent } from './components/portal/bikeshop/print-job-card-till-slip/print-job-card-till-slip.component';
import { ReservationPrintOutComponent } from './components/portal/bikeshop/rentals/reservations/reservation-print-out/reservation-print-out.component';
import { PrintCollectionsComponent } from './components/portal/bikeshop/print-collections/print-collections.component';
import { RentalsProductsImportComponent } from './components/portal/bikeshop/rentals/rentals-products-import/rentals-products-import.component';
import { JobcardWaiverComponent } from './components/modals/update-jobcard/jobcard-waiver/jobcard-waiver.component';
import { WorkshopWaiversComponent } from './components/portal/bikeshop/workshop-waivers/workshop-waivers.component';
import { CustomQuestionResponsesComponent } from './components/modals/update-jobcard/custom-question-responses/custom-question-responses.component';
import { WorkshopCustomQuestionsComponent } from './components/portal/bikeshop/workshop-custom-questions/workshop-custom-questions.component';
import { UiLongPressDirective } from './directives/long-press.directive';
import { PosSyncStatusComponent } from './components/portal/bikeshop/pos-sync-status/pos-sync-status.component';
import { DazzleIconComponent } from './components/shared/dazzle-icons/dazzle-icon.component';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { MenuPanelComponent } from './components/shared/menu-panel/menu-panel.component';
import { RentalsDeliverySummaryComponent } from './components/portal/bikeshop/rentals/rentals-delivery-summary/rentals-delivery-summary.component';
import { RentalsDeliveriesCollectionsConfigurationComponent } from './components/portal/bikeshop/rentals/rentals-deliveries-collections-configuration/rentals-deliveries-collections-configuration.component';
import { EditStoreSubscriptionComponent } from './components/portal/superuser/super-user-portal/cycle-shops/edit-store-subscription/edit-store-subscription.component';
import { WhatsappIntegrationComponent } from './components/portal/bikeshop/whatsapp-integration/whatsapp-integration.component';
import { WhatsappPlaygroundComponent } from './components/portal/bikeshop/whatsapp-integration/whatsapp-playground/whatsapp-playground.component';
import { XeroComponent } from './components/prelogin/xero/xero.component';
import { XerocallbackComponent } from './components/prelogin/xerocallback/xerocallback.component';
import { WhatsappTemplatesComponent } from './components/portal/bikeshop/whatsapp-integration/whatsapp-templates/whatsapp-templates.component';
import { WhatsappInitiateChatTemplateComponent } from './components/portal/bikeshop/whatsapp-integration/whatsapp-initiate-chat-template/whatsapp-initiate-chat-template.component';
import { Project529ModalComponent } from './components/modals/project529-modal/project529-modal.component';
import { ErrorsComponent as ModalErrorsComponent } from './components/modals/errors/errors.component';
import { ErrorsComponent } from './components/portal/superuser/super-user-portal/errors/errors.component';
import { ViewComponent as ErrorViewComponent } from './components/portal/superuser/super-user-portal/errors/view/view.component';
import {
  TokenManagementComponent
} from "./components/portal/superuser/super-user-portal/token-managment/token-management.component";
import { SyncProgressComponent } from './components/portal/superuser/super-user-portal/sync-progress/sync-progress.component';
import {
  ViewTokenModalComponent
} from "./components/portal/superuser/super-user-portal/token-managment/modals/view-token-modal/view-token-modal.component";
import {
  RevokeTokenModalComponent
} from "./components/portal/superuser/super-user-portal/token-managment/modals/revoke-token-modal/revoke-token-modal.component";
import {
  CreateTokenModalComponent
} from "./components/portal/superuser/super-user-portal/token-managment/modals/create-token-modal/create-token-modal.component";
import { InitiateServicePaymentRefundComponent } from './components/modals/update-jobcard/quote/service-payment-history/initiate-service-payment-refund/initiate-service-payment-refund.component';
import { InitiateRentalPaymentRefundComponent } from './components/portal/bikeshop/rentals/reservations/rental-reservation-update/rental-payment-status/initiate-rental-payment-refund/initiate-rental-payment-refund.component';
import { WorkshopJobcardComponent } from './components/modals/workshop-jobcard/workshop-jobcard.component';
import { WorkshopJobcardHeaderComponent } from './components/modals/workshop-jobcard/workshop-jobcard-header/workshop-jobcard-header.component';
import { HubtigerButtonComponent } from './components/controls/buttons/hubtiger-button/hubtiger-button.component';
import { WorkshopJobcardBookingDetailsComponent } from './components/modals/workshop-jobcard/workshop-jobcard-booking-details/workshop-jobcard-booking-details.component';
import { WorkshopJobcardCustomerDetailsComponent } from './components/modals/workshop-jobcard/workshop-jobcard-customer-details/workshop-jobcard-customer-details.component';
import { WorkshopJobcardItemDetailsComponent } from './components/modals/workshop-jobcard/workshop-jobcard-item-details/workshop-jobcard-item-details.component';
import { WorkshopJobcardQuoteComponent } from './components/modals/workshop-jobcard/workshop-jobcard-quote/workshop-jobcard-quote.component';
import { WorkshopJobcardChecklistsComponent } from './components/modals/workshop-jobcard/workshop-jobcard-checklists/workshop-jobcard-checklists.component';
import { WorkshopJobcardCollecionsDeliveriesComponent } from './components/modals/workshop-jobcard/workshop-jobcard-collecions-deliveries/workshop-jobcard-collecions-deliveries.component';
import { WorkshopJobcardCustomQuestionsComponent } from './components/modals/workshop-jobcard/workshop-jobcard-custom-questions/workshop-jobcard-custom-questions.component';


import { HubUIModule } from './components/ui-components/hub-ui.module';
import { WorkshopJobcardAccordionComponent } from './components/modals/workshop-jobcard/workshop-jobcard-accordion/workshop-jobcard-accordion.component';
import { WorkshopJobcardQuoteSearchAreaComponent } from './components/modals/workshop-jobcard/workshop-jobcard-quote-search-area/workshop-jobcard-quote-search-area.component';
import { WorkshopJobcardCreateCollectionComponent } from './components/modals/workshop-jobcard/workshop-jobcard-quote-search-area/workshop-jobcard-create-collection/workshop-jobcard-create-collection.component';
import { WorkshopJobcardManageCollectionsComponent } from './components/modals/workshop-jobcard/workshop-jobcard-quote-search-area/workshop-jobcard-manage-collections/workshop-jobcard-manage-collections.component';
import { WorkshopJobcardSaveToCollectionComponent } from './components/modals/workshop-jobcard/workshop-jobcard-quote-search-area/workshop-jobcard-save-to-collection/workshop-jobcard-save-to-collection.component';
import { WorkshopJobcardAddCouponComponent } from './components/modals/workshop-jobcard/workshop-jobcard-quote/workshop-jobcard-add-coupon/workshop-jobcard-add-coupon.component';
import { WorkshopJobcardCreateSpecialOrderComponent } from './components/modals/workshop-jobcard/workshop-jobcard-quote/workshop-jobcard-create-special-order/workshop-jobcard-create-special-order.component';
import { WorkshopJobcardAddLineitemNoteComponent } from './components/modals/workshop-jobcard/workshop-jobcard-quote/workshop-jobcard-add-lineitem-note/workshop-jobcard-add-lineitem-note.component';
import { WorkshopJobcardEditLineitemComponent } from './components/modals/workshop-jobcard/workshop-jobcard-quote/workshop-jobcard-edit-lineitem/workshop-jobcard-edit-lineitem.component';
import { WorkshopJobcardQuoteSearchLoaderComponent } from './components/modals/workshop-jobcard/workshop-jobcard-quote-search-area/workshop-jobcard-quote-search-loader/workshop-jobcard-quote-search-loader.component';

import { TextMessagePlatformIntegrationComponent } from './components/portal/bikeshop/text-message-platform-integration/text-message-platform-integration.component';
import { CallbackTextMessagePlatformComponent } from './components/portal/bikeshop/text-message-platform-integration/callback-text-message-platform/callback-text-message-platform.component';
import { RentalsServiceIndicatorsConfigComponent } from './components/portal/bikeshop/rentals/rentals-service-indicators-config/rentals-service-indicators-config.component';
import { RentalServiceIndicatorConfigSidebarComponent } from './components/portal/bikeshop/rentals/rentals-service-indicators-config/rental-service-indicator-config-sidebar/rental-service-indicator-config-sidebar.component';
import { RentalsServiceIndicatorStatusReportComponent } from './components/portal/bikeshop/rentals/rentals-service-indicator-status-report/rentals-service-indicator-status-report.component';
import { ReservationProductServiceIndicatorComponent } from './components/portal/bikeshop/rentals/reservations/rental-reservation-update/rental-reservation-job-card/reservation-product-service-indicator/reservation-product-service-indicator.component';
import { LinkTwilioComponent } from './components/portal/bikeshop/text-message-platform-integration/link-twilio/link-twilio.component';
import { ConnectTextMessagePlatformComponent } from './components/modals/connect-text-message-platform/connect-text-message-platform.component';
import { LinkCoaxComponent } from './components/portal/bikeshop/text-message-platform-integration/link-coax/link-coax.component';
import { LinkPodiumComponent } from './components/portal/bikeshop/text-message-platform-integration/link-podium/link-podium.component';
import { WorkshopJobcardSearchCustomerComponent } from './components/modals/workshop-jobcard/workshop-jobcard-customer-details/workshop-jobcard-search-customer/workshop-jobcard-search-customer.component';
import { WorkshopJobcardSearchSerialNumberComponent } from './components/modals/workshop-jobcard/workshop-jobcard-search-serial-number/workshop-jobcard-search-serial-number.component';
import { WorkshopJobcardCreateCustomerComponent } from './components/modals/workshop-jobcard/workshop-jobcard-customer-details/workshop-jobcard-create-customer/workshop-jobcard-create-customer.component';
import { WorkshopJobcardEditCustomerComponent } from './components/modals/workshop-jobcard/workshop-jobcard-customer-details/workshop-jobcard-edit-customer/workshop-jobcard-edit-customer.component';
import { WorkshopJobcardCustomerSearchSkeletonLoaderComponent } from './components/modals/workshop-jobcard/workshop-jobcard-customer-details/workshop-jobcard-search-customer/workshop-jobcard-customer-search-skeleton-loader/workshop-jobcard-customer-search-skeleton-loader.component';
import { WorkshopJobcardDeleteCustomerComponent } from './components/modals/workshop-jobcard/workshop-jobcard-customer-details/workshop-jobcard-delete-customer/workshop-jobcard-delete-customer.component';
import { WorkshopJobcardCustomerExistsComponent } from './components/modals/workshop-jobcard/workshop-jobcard-customer-details/workshop-jobcard-customer-exists/workshop-jobcard-customer-exists.component';
import { WorkshopJobcardAddBookingNotesComponent } from './components/modals/workshop-jobcard/workshop-jobcard-customer-details/workshop-jobcard-add-booking-notes/workshop-jobcard-add-booking-notes.component';
import { WorkshopJobcardListCustomerItemsComponent } from './components/modals/workshop-jobcard/workshop-jobcard-item-details/workshop-jobcard-list-customer-items/workshop-jobcard-list-customer-items.component';
import { WorkshopJobcardAddCustomerItemComponent } from './components/modals/workshop-jobcard/workshop-jobcard-item-details/workshop-jobcard-add-customer-item/workshop-jobcard-add-customer-item.component';
import { WorkshopJobcardUpdateCustomerItemComponent } from './components/modals/workshop-jobcard/workshop-jobcard-item-details/workshop-jobcard-update-customer-item/workshop-jobcard-update-customer-item.component';
import { WorkshopJobcardPreServiceChecksComponent } from './components/modals/workshop-jobcard/workshop-jobcard-checklists/workshop-jobcard-pre-service-checks/workshop-jobcard-pre-service-checks.component';
import { WorkshopJobcardGroupJobsModalComponent } from './components/modals/workshop-jobcard/workshop-jobcard-group-jobs-modal/workshop-jobcard-group-jobs-modal.component';
import { WorkshopJobcardCustomQuestionDetailsComponent } from './components/modals/workshop-jobcard/workshop-jobcard-custom-questions/workshop-jobcard-custom-question-details/workshop-jobcard-custom-question-details.component';
import { WorkshopJobcardCollectionsDeliveriesDetailsComponent } from './components/modals/workshop-jobcard/workshop-jobcard-collecions-deliveries/workshop-jobcard-collections-deliveries-details/workshop-jobcard-collections-deliveries-details.component';
import { WorkshopJobcardExtrasComponent } from './components/modals/workshop-jobcard/workshop-jobcard-extras/workshop-jobcard-extras.component';
import { WorkshopJobcardAccordionManageComponent } from './components/modals/workshop-jobcard/workshop-jobcard-accordion-manage/workshop-jobcard-accordion-manage.component';
import { WorkshopJobcardLiveUpdatesComponent } from './components/modals/workshop-jobcard/workshop-jobcard-live-updates/workshop-jobcard-live-updates.component';
import { WorkshopJobcardMessagingAttachmentsComponent } from './components/modals/workshop-jobcard/workshop-jobcard-live-updates/workshop-jobcard-messaging-attachments/workshop-jobcard-messaging-attachments.component';
import { WorkshopJobcardInternalExternalNotesComponent } from './components/modals/workshop-jobcard/workshop-jobcard-live-updates/workshop-jobcard-internal-external-notes/workshop-jobcard-internal-external-notes.component';
import { WorkshopJobcardTransferComponent } from './components/modals/workshop-jobcard/workshop-jobcard-live-updates/workshop-jobcard-transfer/workshop-jobcard-transfer.component';
import { WorkshopJobcardCancelOptionsComponent } from './components/modals/workshop-jobcard/workshop-jobcard-live-updates/workshop-jobcard-cancel-options/workshop-jobcard-cancel-options.component';
import { WorkshopJobcardCreateSkuComponent } from './components/modals/workshop-jobcard/workshop-jobcard-quote-search-area/workshop-jobcard-create-sku/workshop-jobcard-create-sku.component';
import { WorkshopJobcardQuoteOptionsComponent } from './components/modals/workshop-jobcard/workshop-jobcard-quote/workshop-jobcard-quote-options/workshop-jobcard-quote-options.component';
import { WorkshopJobcardSkeletonLoaderComponent } from './components/modals/workshop-jobcard/workshop-jobcard-skeleton-loader/workshop-jobcard-skeleton-loader.component';
import { WorkshopJobcardQuotePaymentsComponent } from './components/modals/workshop-jobcard/workshop-jobcard-quote/workshop-jobcard-quote-payments/workshop-jobcard-quote-payments.component';
import { WorkshopJobcardInitiateRefundComponent } from './components/modals/workshop-jobcard/workshop-jobcard-quote/workshop-jobcard-quote-payments/workshop-jobcard-initiate-refund/workshop-jobcard-initiate-refund.component';
import { WorkshopJobcardServiceChecklistsComponent } from './components/modals/workshop-jobcard/workshop-jobcard-live-updates/workshop-jobcard-service-checklists/workshop-jobcard-service-checklists.component';
import { WorkshopJobcardServiceWaiversComponent } from './components/modals/workshop-jobcard/workshop-jobcard-live-updates/workshop-jobcard-service-waivers/workshop-jobcard-service-waivers.component';
import { WorkshopJobcardLinkedServicesComponent } from './components/modals/workshop-jobcard/workshop-jobcard-linked-services/workshop-jobcard-linked-services.component';
import { WorkshopJobcardLinkServicesComponent } from './components/modals/workshop-jobcard/workshop-jobcard-linked-services/workshop-jobcard-link-services/workshop-jobcard-link-services.component';

import { LinkHeartlandsComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-heartlands/link-heartlands.component';
import { HeartlandsDefaultsComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-heartlands/heartlands-defaults/heartlands-defaults.component';
import { HeartlandsCallbackComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-heartlands/heartlands-callback/heartlands-callback.component';
import { WorkshopServicesKanbanComponent } from './components/portal/bikeshop/workshop-services-kanban/workshop-services-kanban.component';
import { LinkDearComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-dear/link-dear.component';
import { DearDefaultsComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-dear/dear-defaults/dear-defaults.component';
import { WorkshopJobcardBookingDetailsModalComponent } from './components/modals/workshop-jobcard/workshop-jobcard-booking-details-modal/workshop-jobcard-booking-details-modal.component';
import { WorkshopJobcardNotesPreviewComponent } from './components/modals/workshop-jobcard/workshop-jobcard-live-updates/workshop-jobcard-notes-preview/workshop-jobcard-notes-preview.component';
import { WorkshopJobcardCollectionsDeliveriesPreviewComponent } from './components/modals/workshop-jobcard/workshop-jobcard-live-updates/workshop-jobcard-collections-deliveries-preview/workshop-jobcard-collections-deliveries-preview.component';
import { WorkshopJobcardCustomQuestionsPreviewComponent } from './components/modals/workshop-jobcard/workshop-jobcard-live-updates/workshop-jobcard-custom-questions-preview/workshop-jobcard-custom-questions-preview.component';
import { WorkshopJobcardMessagingPreviewComponent } from './components/modals/workshop-jobcard/workshop-jobcard-live-updates/workshop-jobcard-messaging-preview/workshop-jobcard-messaging-preview.component';
import { VersionUpdateComponent } from './components/modals/version-update/version-update.component';
import { SessionExpiredComponent } from './components/modals/session-expired/session-expired.component';
import { WorkshopJobcardLiveNotesComponent } from './components/modals/workshop-jobcard/workshop-jobcard-live-notes/workshop-jobcard-live-notes.component';
import { WorkshopActiveJobcardTimersComponent } from './components/portal/bikeshop/workshop-active-jobcard-timers/workshop-active-jobcard-timers.component';
import { WorkshopJobcardJobcardTimerComponent } from './components/modals/workshop-jobcard/workshop-jobcard-jobcard-timer/workshop-jobcard-jobcard-timer.component';
import { WorkshopJobcardLiveStatusesComponent } from './components/modals/workshop-jobcard/workshop-jobcard-live-statuses/workshop-jobcard-live-statuses.component';
import { WorkshopJobcardAuditLogsComponent } from './components/modals/workshop-jobcard/workshop-jobcard-live-updates/workshop-jobcard-audit-logs/workshop-jobcard-audit-logs.component'

import { LinkTeamworkComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-teamwork/link-teamwork.component';
import { LinkErplyComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-erply/link-erply.component';
import { TeamworkDefaultsComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-teamwork/teamwork-defaults/teamwork-defaults.component';
import { LinkAscendComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-ascend/link-ascend.component';
import { AscendDefaultsComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-ascend/ascend-defaults/ascend-defaults.component';
import { CyclistAddressBikeComponent } from './components/shared/cyclist-address-bike/cyclist-address-bike.component';
import { EditUserComponent } from './components/modals/add-edit-user/edit-user/edit-user.component';
import { EditUserAddressesComponent } from './components/modals/add-edit-user/edit-user-addresses/edit-user-addresses.component';

import { MsalModule, MsalRedirectComponent, MsalService } from '@azure/msal-angular';
import { InteractionType, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { TrekGigyaLoginComponent } from './components/prelogin/trek-gigya-login/trek-gigya-login.component';

// Receipt Template Designer
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ReceiptTemplateDesignerComponent } from './components/portal/bikeshop/receipt-template-designer/receipt-template-designer.component';
import { TemplateEditorComponent } from './components/portal/bikeshop/receipt-template-designer/editor/template-editor.component';
import { MergeTagsPanelComponent } from './components/portal/bikeshop/receipt-template-designer/editor/merge-tags-panel/merge-tags-panel.component';
import { TemplateCanvasComponent } from './components/portal/bikeshop/receipt-template-designer/editor/template-canvas/template-canvas.component';
import { CanvasElementComponent } from './components/portal/bikeshop/receipt-template-designer/editor/canvas-element/canvas-element.component';
import { ElementPropertiesComponent } from './components/portal/bikeshop/receipt-template-designer/editor/element-properties/element-properties.component';
import { PrintTemplateModalComponent } from './components/portal/bikeshop/receipt-template-designer/print-template-modal/print-template-modal.component';
import { ReceiptTemplatePrintPageComponent } from './components/portal/bikeshop/receipt-template-designer/print-page/receipt-template-print-page.component';
import { SelectPrintTemplateModalComponent } from './components/portal/bikeshop/receipt-template-designer/select-print-template-modal/select-print-template-modal.component';
import { ItemTransferComponent } from './components/modals/item-transfer/item-transfer.component';
import { WorkshopJobcardTagSelectComponent } from './components/modals/workshop-jobcard/workshop-jobcard-tag-select/workshop-jobcard-tag-select.component';
import { ItemServiceHistoryComponent } from './components/modals/item-service-history/item-service-history.component';
import { WorkshopJobcardAuditTrailComponent } from './components/modals/workshop-jobcard/workshop-jobcard-live-updates/workshop-jobcard-audit-trail/workshop-jobcard-audit-trail.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    EntraLoginComponent,
    ForgotpasswordComponent,
    InsuranceloginComponent,
    HelpRequestComponent,
    BikeshopWizardComponent,
    CallbackXeroComponent,
    CallbackLightspeedComponent,
    CallbackVendComponent,
    CallbackShopifyComponent,
    CallbackSquareComponent,
    StripeConnectCallbackComponent,
    TFACodeComponent,
    TFASetupComponent,
    PortalComponent,
    QuickLaunchComponent,
    DashboardComponent,
    RecordPaymentDetailsComponent,
    ManageSubscriptionsComponent,
    DueForServiceDetailComponent,
    MyprofileComponent,
    TFAProfileSetupComponent,
    CalendarComponent,
    ReportsComponent,
    ServicesComponent,
    ServicesComponent,
    MessageTypesComponent,
    PurchaseMessagingBundleComponent,
    PosProductsComponent,
    ImportProductsComponent,
    PosProductsAddToCollectionComponent,
    AddEditServicesComponent,
    ServiceTypesComponent,
    ServiceTypesComponent,
    ImportServiceTypesComponent,
    ChecklistItemsComponent,
    ChecklistConfigurationComponent,
    ShopProfileComponent,
    SettingsComponent,
    PosIntegrationsComponent,
    CollectionsSetupV2Component,
    CyclistsComponent,
    ImportCyclistsComponent,
    CyclistsComponent,
    ImportCyclistsComponent,
    UsersV2Component,
    UsersComponent,
    ThirdPartyComponent,
    SpecialOrdersComponent,
    CollectionsComponent,
    CommunityComponent,
    CommunicationComponent,
    InAppPaymentConfigurationComponent,
    InsuranceQuoteCreationComponent,
    SwitchShopComponent,
    OtherSettingsComponent,
    OnlineWidgetComponent,
    CouponsComponent,
    CouponDetailComponent,
    JobCardMessagesComponent,
    ExternalRedirectComponent,
    BikeSalesComponent,
    InventoryAuditComponent,
    InventorySummaryComponent,
    ServiceImportsComponent,
    WidgetSetupComponent,
    ShopRidesComponent,
    CreateEditRideComponent,
    ShopRidesConfigurationComponent,
    ReferralsComponent,
    ProductRedirectLoaderComponent,
    ServiceDepositConfigurationComponent,
    RentalsConfigurationComponent,
    RentalsTimeConfigurationComponent,
    RentalsProductsAccessoriesComponent,
    RentalsFixedDurationConfigComponent,
    RentalsFixedDurationConfigComponent,
    RentalsFlexibleDurationConfigComponent,
    ReservationsComponent,
    RentalsChecklistsComponent,
    RentalsCategoriesComponent,
    RentalsReservationsSummaryComponent,
    RentalsSettingsComponent,
    UsersV2Component,
    JobCardMessagesComponent,
    CyclistsComponent,
    ImportCyclistsComponent,
    CyclistsComponent,
    ImportCyclistsComponent,
    PosIntegrationsComponent,
    PurchaseMessagingBundleComponent,
    RecordPaymentDetailsComponent,
    ManageSubscriptionsComponent,
    ShopProfileComponent,
    PosProductsComponent,
    InAppPaymentConfigurationComponent,
    SwitchShopComponent,
    RentalReportsComponent,
    RentalCustomWidgetQuestionsComponent,
    PaystackIntegrationConfigurationComponent,
    RentalsSplitPaymentConfigurationComponent,
    RentalAffiliatesComponent,
    RentalAffiliateCommissionReportComponent,
    RentalsWidgetConfigurationComponent,
    DemosWidgetConfigurationComponent,
    PageNotFoundComponent,
    AddEditLeaveComponent,
    AddEditCloseDateComponent,
    SharedServiceComponent,
    CreateCommunicationComponent,
    AddEditStaffLeaveComponent,
    AvailabilityComponent,
    AddEditBikesaleItemComponent,
    AvatarComponent,
    ServiceTypeMessageTemplatesComponent,
    ServiceTypeMessageTemplateComponent,
    VideoPlayerComponent,
    UserEditComponent,
    UpdateJobcardComponent,
    SelectTechnicianModalComponent,
    ScheduleServiceComponent,
    RecordBikeSaleComponent,
    StripeBundlePaymentComponent,
    ConnectPosComponent,
    ChangeMyPasswordComponent,
    CardDetailsComponent,
    CancelPackageComponent,
    AddEditUserComponent,
    AddEditServiceTypeV2Component,
    ServiceDropoffComponent,
    JobcardApprovalComponent,
    InsuranceQuotesComponent,
    ProcurementComponent,
    ClaimInfoComponent,
    JobcardMultiQuoteApprovalComponent,
    ClaimComponent,
    ViewClaimsComponent,
    ViewTasksComponent,
    CreateClaimComponent,
    InsuranceComponent,
    SingleManufacturerBikeComponent,
    CyclistResetPasswordComponent,
    JobcardChecklistsComponent,
    JobcardAttachmentsPhoneComponent,
    JobcardInvoicesComponent,
    JobcardMessagingComponent,
    JobcardReviewComponent,
    CyclistPortalComponent,
    CyclistPaymentComponent,
    WizardServiceTypesComponent,
    WizardLinkPosComponent,
    WizardUsersComponent,
    SharedServiceTypesComponent,
    LinkVendComponent,
    LinkLightspeedComponent,
    LinkXeroComponent,
    LinkShopifyComponent,
    LinkNorthmillComponent,
    LinkRetailexpressComponent,
    LinkCitruslimeComponent,
    LinkEposnowComponent,
    LinkWilmarComponent,
    LinkNetsuiteComponent,
    LinkSquareComponent,
    LinkPodiumComponent,
    VendDefaultsComponent,
    SquareDefaultsComponent,
    ShopifyDefaultsComponent,
    NetsuiteDefaultsComponent,
    LightspeedDefaultsComponent,
    WizardShopProfileComponent,
    WizardAccountVerificationComponent,
    WizardRegistrationComponent,
    PasswordStrengthComponent,
    TrailsManagementComponent,
    TrailAddEditComponent,
    SuperUserPortalComponent,
    PushNotificationBroadcastComponent,
    MessagingBundleAdminComponent,
    CycleShopsComponent,
    GearTypeAdvicesComponent,
    GearTypeAdviceComponent,
    BikeGearManagementComponent,
    AnalyticsDashboardComponent,
    StatusNamesPipe,
    FranchiseComponent,
    AdminTasksComponent,
    CopyShopsComponent,
    MergeCyclistComponent,
    SafeHtmlPipe,
    StaffComponent,
    WorkingScheduleComponent,
    ClosingDatesComponent,
    StaffLeaveComponent,
    TechniciansReorderComponent,
    EditEventComponent,
    AddMessagingBundleComponent,
    AddEditUserV2Component,
    AddEditFranchiseComponent,
    TechniciansScheduleComponent,
    AvailabilityCalendarComponent,
    AddEditThirdPartyComponent,
    MenuCardComponent,
    DateFormatPipe,
    AddEditRentalProductComponent,
    BookRentalReservationComponent,
    RentalReservationUpdateComponent,
    RentalReservationWaiverComponent,
    RentalReservationChecklistComponent,
    RentalReservationMessagingComponent,
    RentalReservationQuoteComponent,
    RentalReservationJobCardComponent,
    RentalReservationSummaryDetailComponent,
    AddEditProductCategoriesComponent,
    RentalReservationSecurityDepositInfoComponent,
    CaptureAuthorizedPaymentComponent,
    RentalReservationLongTermPaymentScheduleComponent,
    RentalPaymentStatusComponent,
    RentalsAvailabilityDatePickerComponent,
    OverviewWidgetComponent,
    DeliveryVehicleConfigComponent,
    CyclistComponent,
    RentalCustomPickupSlotsComponent,
    RentalOverrideStoreTimesComponent,
    AddEditRentalOverrideStoreTimeComponent,
    AddEditRentalCustomPickupSlotComponent,
    RentalsLinkAccessoriesProductsComponent,
    RentalAccessoriesComponent,
    RentalProductsComponent,
    AddEditRentalAccessoryComponent,
    AddEditFlexiblePriceGroupComponent,
    AddEditPriceGroupComponent,
    BetaMessageComponent,
    RentalAccessoryCategoriesComponent,
    RentalProductCategoriesComponent,
    RentalAffiliateConfigComponent,
    ProductAddEditComponent,
    CurrencyVATPipe,
    LinkifyPipe,
    EposnowDefaultsComponent,
    CitruslimeDefaultsComponent,
    RetailexpressDefaultsComponent,
    MessageTypePanelComponent,
    AddEditAccessoryCategoriesComponent,
    SubscriptionPaymentComponent,
    SetupPeachPaymentsComponent,
    ConnectStripeComponent,
    ConfigurationOverviewComponent,
    HubtigerStarRatingComponent,
    OverrideSlotsConfigComponent,
    UnavailableDatesConfigComponent,
    DefaultSlotsConfigComponent,
    DeliveryAreaConfigComponent,
    AddEditChecklistItemComponent,
    ResetPasswordComponent,
    LinkedFittingsComponent,
    LinkedServiceTypesComponent,
    TechnicianAvailabilityComponent,
    LinkNewUserComponent,
    FittingInfoComponent,
    LinkJobcardsComponent,
    ChecklistComponent,
    CollectionsTabComponent,
    JobcardAttachmentsComponent,
    MessagingComponent,
    BikeComponent,
    RentalsAvailabilityDatePickerComponent,
    QuoteComponent,
    JobcardComponent,
    ComponentViewComponent,
    UserComponent,
    TechnicianComponent,
    TechnicianWorkingHoursComponent,
    BikesComponent,
    CyclistBikeComponent,
    MoveJobcardComponent,
    AddProductPanelComponent,
    EditWorkingHoursComponent,
    SkeletonLoadJobcardComponent,
    ServicePaymentHistoryComponent,
    QuoteOptionsComponent,
    AddCyclistBikeComponent,
    ComponentEditComponent,
    EventComponent,
    PrintComponent,
    PrintJobCardTillSlipComponent,
    ReservationPrintOutComponent,
    PrintCollectionsComponent,
    RentalsProductsImportComponent,
    JobcardWaiverComponent,
    WorkshopWaiversComponent,
    CustomQuestionResponsesComponent,
    WorkshopCustomQuestionsComponent,
    PosSyncStatusComponent,
    MenuPanelComponent,
    RentalsDeliverySummaryComponent,
    RentalsDeliveriesCollectionsConfigurationComponent,
    EditStoreSubscriptionComponent,
    WhatsappIntegrationComponent,
    WhatsappPlaygroundComponent,
    XeroComponent,
    XerocallbackComponent,
    WhatsappTemplatesComponent,
    WhatsappInitiateChatTemplateComponent,
    Project529ModalComponent,
    ModalErrorsComponent,
    ErrorsComponent,
    ErrorViewComponent,
    TokenManagementComponent,
    SyncProgressComponent,
    ViewTokenModalComponent,
    RevokeTokenModalComponent,
    CreateTokenModalComponent,
    InitiateServicePaymentRefundComponent,
    InitiateRentalPaymentRefundComponent,
    TextMessagePlatformIntegrationComponent,
    CallbackTextMessagePlatformComponent,
    RentalsServiceIndicatorsConfigComponent,
    RentalServiceIndicatorConfigSidebarComponent,
    RentalsServiceIndicatorStatusReportComponent,
    ReservationProductServiceIndicatorComponent,
    ConnectTextMessagePlatformComponent,
    LinkCoaxComponent,
    WorkshopJobcardComponent,
    WorkshopJobcardHeaderComponent,
    HubtigerButtonComponent,
    WorkshopJobcardBookingDetailsComponent,
    WorkshopJobcardCustomerDetailsComponent,
    WorkshopJobcardItemDetailsComponent,
    WorkshopJobcardQuoteComponent,
    WorkshopJobcardChecklistsComponent,
    WorkshopJobcardCollecionsDeliveriesComponent,
    WorkshopJobcardCustomQuestionsComponent,
    WorkshopJobcardAccordionComponent,
    WorkshopJobcardQuoteSearchAreaComponent,
    WorkshopJobcardCreateCollectionComponent,
    WorkshopJobcardManageCollectionsComponent,
    WorkshopJobcardSaveToCollectionComponent,
    WorkshopJobcardAddCouponComponent,
    WorkshopJobcardCreateSpecialOrderComponent,
    WorkshopJobcardAddLineitemNoteComponent,
    WorkshopJobcardEditLineitemComponent,
    WorkshopJobcardQuoteSearchLoaderComponent,
    TextMessagePlatformIntegrationComponent,
    CallbackTextMessagePlatformComponent,
    RentalsServiceIndicatorsConfigComponent,
    RentalServiceIndicatorConfigSidebarComponent,
    RentalsServiceIndicatorStatusReportComponent,
    ReservationProductServiceIndicatorComponent,
    LinkHeartlandsComponent,
    HeartlandsDefaultsComponent,
    WorkshopJobcardSearchCustomerComponent,
    WorkshopJobcardSearchSerialNumberComponent,
    WorkshopJobcardCreateCustomerComponent,
    WorkshopJobcardEditCustomerComponent,
    WorkshopJobcardCustomerSearchSkeletonLoaderComponent,
    WorkshopJobcardDeleteCustomerComponent,
    WorkshopJobcardCustomerExistsComponent,
    WorkshopJobcardAddBookingNotesComponent,
    WorkshopJobcardListCustomerItemsComponent,
    WorkshopJobcardAddCustomerItemComponent,
    WorkshopJobcardUpdateCustomerItemComponent,
    WorkshopJobcardPreServiceChecksComponent,
    WorkshopJobcardGroupJobsModalComponent,
    WorkshopJobcardCustomQuestionDetailsComponent,
    WorkshopJobcardCollectionsDeliveriesDetailsComponent,
    WorkshopJobcardExtrasComponent,
    WorkshopJobcardAccordionManageComponent,
    WorkshopJobcardLiveUpdatesComponent,
    WorkshopJobcardMessagingAttachmentsComponent,
    WorkshopJobcardInternalExternalNotesComponent,
    WorkshopJobcardTransferComponent,
    WorkshopJobcardCancelOptionsComponent,
    WorkshopJobcardCreateSkuComponent,
    WorkshopJobcardQuoteOptionsComponent,
    WorkshopJobcardSkeletonLoaderComponent,
    LinkHeartlandsComponent,
    HeartlandsDefaultsComponent,
    HeartlandsCallbackComponent,
    WorkshopServicesKanbanComponent,
    LinkDearComponent,
    DearDefaultsComponent,
    WorkshopJobcardQuotePaymentsComponent,
    WorkshopJobcardInitiateRefundComponent,
    WorkshopJobcardServiceChecklistsComponent,
    WorkshopJobcardServiceWaiversComponent,
    WorkshopJobcardLinkedServicesComponent,
    WorkshopJobcardLinkServicesComponent,
    LinkTwilioComponent,
    WorkshopJobcardBookingDetailsModalComponent,
    WorkshopJobcardNotesPreviewComponent,
    WorkshopJobcardCollectionsDeliveriesPreviewComponent,
    WorkshopJobcardCustomQuestionsPreviewComponent,
    WorkshopJobcardMessagingPreviewComponent,
    VersionUpdateComponent,
    SessionExpiredComponent,
    WorkshopJobcardLiveNotesComponent,
    WorkshopActiveJobcardTimersComponent,
    WorkshopJobcardJobcardTimerComponent,
    WorkshopJobcardLiveStatusesComponent,
    WorkshopJobcardAuditLogsComponent,
    DearDefaultsComponent,
    LinkTeamworkComponent,
    LinkErplyComponent,
    TeamworkDefaultsComponent,
    LinkAscendComponent,
    AscendDefaultsComponent,
    TrekGigyaLoginComponent,
    //TeamworkDefaultsComponent,
    CyclistAddressBikeComponent,
    EditUserComponent,
    EditUserAddressesComponent,
    //TeamworkDefaultsComponent,
    //TeamworkDefaultsComponent,
    // Receipt Template Designer
    ReceiptTemplateDesignerComponent,
    TemplateEditorComponent,
    MergeTagsPanelComponent,
    TemplateCanvasComponent,
    CanvasElementComponent,
    ElementPropertiesComponent,
    PrintTemplateModalComponent,
    ReceiptTemplatePrintPageComponent,
    SelectPrintTemplateModalComponent,
    ItemTransferComponent,
    ItemServiceHistoryComponent,
    WorkshopJobcardTagSelectComponent,
    WorkshopJobcardAuditTrailComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    HttpClientModule,
    InputTextModule,

    // PrimeNg Modules:
    SelectButtonModule,
    FileUploadModule,
    SidebarModule,
    DialogModule,
    MenuModule,
    PanelMenuModule,
    StepsModule,
    TabMenuModule,
    ProgressSpinnerModule,
    DataViewModule,
    TableModule,
    ButtonModule,
    ToastModule,
    DropdownModule,
    MultiSelectModule,
    InputTextModule,
    TabViewModule,
    InputTextareaModule,
    CardModule,
    RadioButtonModule,
    AutoCompleteModule,
    CarouselModule,
    ProgressBarModule,
    OverlayPanelModule,
    CheckboxModule,
    CalendarModule,
    MessageModule,
    ConfirmDialogModule,
    //ConfirmationService,
    InputSwitchModule,
    TooltipModule,
    ListboxModule,
    SliderModule,
    InplaceModule,
    ToggleButtonModule,
    GalleriaModule,
    TreeModule,
    ChipsModule,
    SplitButtonModule,
    ToolbarModule,
    // GMapModule,
    BlockUIModule,
    PanelModule,
    FieldsetModule,
    PaginatorModule,
    // LightboxModule, //todo(dcorbett) lightbox was removed
    TreeTableModule,
    PickListModule,
    AccordionModule,
    // end of primeNg modules
    //FullCalendarModule,
    YouTubePlayerModule,
    NgbModule,
    //todo(dcorbett) - removed angular-email-editor
    QuillModule,
    //  RatingModule,    //todo(dcorbett) - starrating not compatible
    EmailEditorModule,
    AngularEditorModule,
    RoundProgressModule,
    ColorPickerModule,
    QRCodeModule,
    CurrencyMaskModule,
    JoyrideModule.forRoot(),
    NgChartsModule,
    FullCalendarModule,
    //PowerBIEmbedModule,    
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDgN5OjRjgvWuzXSvYPEeLWgnMUUmancvU',
      libraries: ['places', 'drawing', 'geometry'],
      apiVersion: '3.64'
    }),
    UiLongPressDirective,
    RatingModule,
    DazzleIconComponent,
    NgxBarcode6Module,
    HubUIModule,
    MsalModule.forRoot(
      msalConfigFactory(new AppConfig(null)), // Inject AppConfig
      {
        interactionType: InteractionType.Redirect,
        authRequest: {
          scopes: ['openid', 'profile', 'email']
        }
      },
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map([])
      }
    ),
    DragDropModule,
    HubUIModule
  ],
  providers: [
    AppConfig,
    ConfirmationService,
    VersionCheckService,
    DatePipe,
    MessageService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
  //return new TranslateHttpLoader(http);
  const Random = new Date().getTime();
  return new TranslateHttpLoader(
    http,
    './assets/i18n/',
    '.json?rand=' + Random,
  );
}

export function msalConfigFactory(appConfig: AppConfig) {
  const entraConfig = appConfig.getEntraConfig();

  return new PublicClientApplication({
    auth: {
      clientId: entraConfig.clientId,
      authority: entraConfig.authority,
      redirectUri: entraConfig.redirectUri,
      postLogoutRedirectUri: entraConfig.redirectUri,
      navigateToLoginRequestUrl: true
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
    system: {
      allowRedirectInIframe: false,
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) return;
          console.log(message);
        },
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}
